import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

/////////////////////////////////////////////////////////////////////
// Redirect to the target

export const BLOGS_REDIRECT_TO_TARGET_TRIGGER = 'BLOGS_REDIRECT_TO_TARGET_TRIGGER';
export interface BlogsRedirectToTargetTriggerAction {
    readonly type: typeof BLOGS_REDIRECT_TO_TARGET_TRIGGER;
    readonly username: string;
    readonly postId: number;
}
export const BLOGS_REDIRECT_TO_TARGET_REQUEST = 'BLOGS_REDIRECT_TO_TARGET_REQUEST';
export interface BlogsRedirectToTargetRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_REDIRECT_TO_TARGET_REQUEST;
    readonly username: string;
    readonly postId: number;
}
export interface BlogsRedirectToTargetNormalizedResponse extends NormalizedResponse {
    readonly result: {};
}
export const BLOGS_REDIRECT_TO_TARGET_SUCCESS = 'BLOGS_REDIRECT_TO_TARGET_SUCCESS';
export interface BlogsRedirectToTargetSuccessAction extends APISuccessAction<BlogsRedirectToTargetNormalizedResponse> {
    readonly type: typeof BLOGS_REDIRECT_TO_TARGET_SUCCESS;
    readonly username: string;
    readonly postId: number;
}
export const BLOGS_REDIRECT_TO_TARGET_FAILURE = 'BLOGS_REDIRECT_TO_TARGET_FAILURE';
export interface BlogsRedirectToTargetFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_REDIRECT_TO_TARGET_FAILURE;
    readonly username: string;
    readonly postId: number;
}

export const blogsRedirectToTargetTrigger =
    (username: string, postId: number): BlogsRedirectToTargetTriggerAction => ({
        type: BLOGS_REDIRECT_TO_TARGET_TRIGGER, username, postId,
    });
export const blogsRedirectToTargetApi = {
    request: (username: string, postId: number): BlogsRedirectToTargetRequestAction => ({
        type: BLOGS_REDIRECT_TO_TARGET_REQUEST, username, postId,
    }),
    success: (username: string, postId: number, response: BlogsRedirectToTargetNormalizedResponse): BlogsRedirectToTargetSuccessAction => ({
        type: BLOGS_REDIRECT_TO_TARGET_SUCCESS, username, postId, response,
    }),
    failure: (username: string, postId: number, error: any): BlogsRedirectToTargetFailureAction => ({
        type: BLOGS_REDIRECT_TO_TARGET_FAILURE, username, postId, error,
    }),
};
